import { Show, createMemo, createSignal, onMount } from "solid-js";

import { Button } from "@/components/Base/Button/Button";
import { t } from "@/i18n";
import { isMobile } from "@/lib/isMobile.ts";
import { cn } from "@/lib/tailwindcssTool.ts";

export default function Cookies() {
  const [cookiesAccepted, setCookiesAccepted] = createSignal(true);

  onMount(() => {
    if (typeof window !== "undefined") {
      setCookiesAccepted(!!localStorage.getItem("cookies"));
    }
  });

  const handleCookie = () => {
    if (typeof window !== "undefined") {
      localStorage.setItem("cookies", "true");
      setCookiesAccepted(true);
    }
  };

  return (
    <Show when={!cookiesAccepted()} fallback={<></>}>
      <div class="fixed bottom-[45px] z-[500] ml-[24px] flex h-[80px] w-[550px] items-center rounded-[8px] bg-[#202221]">
        <div class="mx-[20px] ml-[10px]">
          <img src={"/icons/mdi_biscuit.svg"} class="ml-2 h-[52px] w-[52px]" />
        </div>
        <div
          class={cn(
            "text-general-darkzi text-[14px] font-[500]",
            isMobile() ? "mx-[10px]" : "",
          )}
          onClick={() => {
            window.open(
              "https://img.engames.com/afunbet/COOKIE_BR.pdf?uid=0&ch=3&gno=0&ic=",
              "_blank",
            );
          }}
          innerHTML={`${t("home.cookie_notice", {
            val: `<span class="text-general-main underline hover:cursor-pointer">Cookies</span>`,
          })}`}
        ></div>
        <div>
          <Button
            variant="primary"
            type="button"
            class="bg-linear-to-l from-up-mainbut-r to-up-mainbut-l clickable mx-[10px] inline-block h-[44px] w-[96px] transform rounded-[6px] text-[14px] font-[800]"
            onClick={() => handleCookie()}
          >
            {t("home.accept")}
          </Button>
        </div>
      </div>
    </Show>
  );
}
